const COMPLIANCE_INFORMATION_SECTIONS = Object.freeze([
    'concern-elements',
    'scip-number',
])

const SUBSTANCE_COMPONENTS = Object.freeze([
    'SubstanceV4',
    'SubstanceEditorStructured',
])

const complianceInformationDescriptor = Object.freeze({
    type: 'compliance-information',
    version: 1,
    defaultTitleKey: 'Page(ReceivedRequest):Component(ComplianceInformation):title',
    fallbackTitle: 'Compliance information',
    defaultNavigationTitleKey: 'Page(ReceivedRequest):Component(ComplianceInformation):navigation-title',
    fallbackNavigationTitle: 'Compliance information',
    defaultDescriptionKey: 'Page(ReceivedRequest):Component(ComplianceInformation):description',
    fallbackDescription: 'Review and provide the compliance information requested for this product.',
    capabilities: {
        repeatable: false,
        supportedModes: ['single'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: [
            'request.details',
            'request.legislations',
            'product.card',
            'product.hierarchy',
            'product.concern-substances',
            'product.component-concern-substances',
        ],
        writes: [
            'request.details',
            'product.card',
            'product.concern-substances',
            'product.component-concern-substances',
        ],
    },
    effects: {
        publishes: [
            'request.details.changed',
            'product.card.changed',
            'product.concern-substances.changed',
            'product.component-concern-substances.changed',
        ],
        observes: [
            'request.details.changed',
            'product.card.changed',
        ],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {
            sections: {
                type: 'array',
                items: {
                    type: 'string',
                    enum: COMPLIANCE_INFORMATION_SECTIONS,
                },
                default: COMPLIANCE_INFORMATION_SECTIONS,
            },
            compactView: { type: 'boolean', default: false },
            showProductWeight: { type: 'boolean', default: true },
            showProductWeightMessage: { type: 'boolean', default: true },
            showInformationOwnerSelection: { type: 'boolean', default: false },
            substanceComponent: {
                type: 'string',
                enum: SUBSTANCE_COMPONENTS,
                default: 'SubstanceV4',
            },
            scipNumberRequired: { type: 'boolean', default: false },
        },
    },
    settingsUi: {
        sections: {
            control: 'multi-select',
            labelKey: 'Component(WorkflowBuilder):compliance-information-sections',
            optionsSource: {
                type: 'static',
                values: COMPLIANCE_INFORMATION_SECTIONS,
            },
        },
        compactView: { control: 'switch' },
        showProductWeight: { control: 'switch' },
        showProductWeightMessage: { control: 'switch' },
        showInformationOwnerSelection: { control: 'switch' },
        substanceComponent: {
            control: 'select',
            optionsSource: {
                type: 'static',
                values: SUBSTANCE_COMPONENTS,
            },
        },
        scipNumberRequired: { control: 'switch' },
    },
})

export { COMPLIANCE_INFORMATION_SECTIONS, SUBSTANCE_COMPONENTS, complianceInformationDescriptor }
export default complianceInformationDescriptor
